module.exports = __webpack_public_path__ + "static/media/artajasa.f7ccfa30.png";